import {
  ACCOUNTING_INVOICES_PAGE_PATH,
  ACCOUNTING_INVOICE_SETTINGS_PAGE_PATH,
  ACCOUNTING_REPORT_PAGE_PATH,
  ACCOUNTS_PAGE_PATH,
  ADMINLOGS_PAGE_PATH,
  APIKEYS_PAGE_PATH,
  BODYSTYLES_PAGE_PATH,
  COMPARISION_PAGE_PATH,
  DASHBOARD_PAGE_PATH,
  DEALERPROFILE_PAGE_PATH,
  DEFAULT_GUIDES_PAGE_PATH,
  EDITTRACKER_PAGE_PATH,
  EXPORT_ORDER_PAGE_PATH,
  EXPORT_PAGE_PATH,
  // FEATURE_BANNERS_PAGE_PATH,
  // FEATURE_BANNERS_SETTINGS_PAGE_PATH,
  FAQ_PATH,
  EXPORT_DMS_PATH,
  FEATURE_ICONS_PAGE_PATH,
  FILEMANAGER_PAGE_PATH,
  FLAGS_PAGE_PATH,
  IMPORT_PAGE_PATH,
  INSTA360_PAGE_PATH,
  INVENTORY_PAGE_PATH,
  INVOICING_PAGE_PATH,
  MASTER_COMPOSITIONS_PAGE_PATH,
  MAVIS_PAGE_PATH,
  MAVIS_PRESENTS_PAGE_PATH,
  MAVIS_SETTINGS_PAGE_PATH,
  PAGUIDES_PAGE_PATH,
  PHOTOGRAPHER_PROFILE_PAGE_PATH,
  QUALITY_CONTROL_EDITFLAGS_PAGE_PATH,
  QUALITY_CONTROL_PAGE_PATH,
  REPORTSETTINGS_PAGE_PATH,
  RETRO_OPERATIONS_PATH,
  VIDEOGENERATION_PAGE_PATH,
  VIDEO_PAGE_PATH,
  PROMO_BANNERS_PAGE_PATH,
  PROMO_BILLBOARDS_PAGE_PATH,
  REPORT_STATISTICS_PATH,
  USER_ROLES_PATH,
  TEAMPROFILE_PAGE_PATH,
  MAVIS_GALLERY_PAGE_PATH,
  VEHICLE_GALLERY_PAGE_PATH,
  USERPROFILE_PAGE_PATH,
  INTEGRATION_PAGE_PATH,
  THEME_DOCS_PAGE_PATH,
  DEALERLOG_PAGE_PATH,
  CONFIRMVDS_GALLERY_PAGE_PATH,
  LOGIN_PAGE_PATH,
  INVENTORY_DETAILS_PAGE_PATH,
  NOTIFICATIONS_PAGE_PATH,
  CRONSTATS_PAGE_PATH,
  EDITORPROFILE_PAGE_PATH,
  EDITOR_REPORT_PAGE_PATH,
  SALES_PAGE_PATH,
  PHOTOGRAPHERS_ACCOUNTS_PAGE_PATH,
  IMPORT_DMS_PATH,
  DEVELOPER_ACCESS_PAGE_PATH,
  NEW_INVOICING_PAGE_PATH,
  INVOICE_LOGS_PAGE_PATH,
  LSP_RATE_PATH,
  LSP_INVOICES_PATH,
  RATIO_SETTINGS_PAGE_PATH,
  YOUTUBE_THUMBNAIL_PAGE_PATH,
  AUTOPORT_SETTINGS_PAGE_PATH,
  ANNOUNCEMENT_BANNER_PAGE_PATH,
  EXT360_PAGE_PATH,
  VIN_STATUS_TRACKER,
  OURMISSION_PAGE_PATH,
  BGERROR_GALLERY_PAGE_PATH_VEHID,
  PROMO_BANNER_FAQ_PATH,
  WINDOW_STICKER_DASHBOARD_PATH,
  WINDOW_STICKER_PRICING_PATH,
  VIN_TURNAROUND_PAGE_PATH,
  VEH_UPLOAD_HISTORY_PAGE_PATH
} from '../constants/appPathConst';
import { getTitleOfPage } from './/pageInfo';
import {
  MODULE_SLUG_ACCOUNTS,
  MODULE_SLUG_ADMINLOGS,
  MODULE_SLUG_APIKEY,
  MODULE_MY_PROFILE,
  MODULE_SOCIAL_MEDIA_INTEGRATION,
  MODULE_THEME_DOCS,
  MODULE_SLUG_BODYSTYLES,
  MODULE_CRON_STATS,
  MODULE_SLUG_DASHBOARD,
  MODULE_SLUG_DEALERCOMPARISON,
  MODULE_SLUG_DEALERPROFILE,
  MODULE_SLUG_DEFAULTGUIDES,
  MODULE_SLUG_DOWNLOADREPORTS,
  MODULE_SLUG_EDITFLAGS,
  MODULE_SLUG_EDITTRACKER,
  MODULE_SLUG_EXPORT,
  MODULE_SLUG_EXPORTDMS,
  MODULE_SLUG_EXPORTORDER,
  MODULE_SLUG_FEATUREBANNERLIBRARY,
  MODULE_SLUG_FEATUREBANNERS,
  MODULE_SLUG_FEATUREICONS,
  MODULE_SLUG_FILEMANAGER,
  MODULE_SLUG_FLAGS,
  MODULE_SLUG_IMPORT,
  MODULE_SLUG_INSTA360,
  MODULE_SLUG_INVENTORY,
  MODULE_SLUG_INVOICES,
  MODULE_SLUG_INVOICESETTINGS,
  MODULE_SLUG_INVOICING,
  MODULE_SLUG_MASTERCOMPOSITIONS,
  MODULE_SLUG_MAVIS,
  MODULE_SLUG_MAVISPRESETS,
  MODULE_SLUG_MAVISSETTINGS,
  MODULE_SLUG_PAGUIDESORDER,
  MODULE_SLUG_PASETTINGS,
  MODULE_SLUG_PROFILES,
  MODULE_SLUG_PROMOTIONALBANNER,
  MODULE_SLUG_QUALITYCONTROL,
  MODULE_SLUG_REPORTSETTINGS,
  MODULE_SLUG_REPORTSTATISTICS,
  MODULE_SLUG_RETROOPERATIONS,
  MODULE_SLUG_USERROLES,
  MODULE_SLUG_VIDEO,
  MODULE_SLUG_SALES,
  MODULE_SLUG_VIDEOGENERATION,
  MODULE_EDITOR_REPORT,
  MODULE_SLUG_ACCOUNTS_CREATION_PHOTOGRAPHER,
  MODULE_SLUG_IMPORTDMS,
  MODULE_SLUG_DEVELOPER_ACCESS,
  MODULE_SLUG_LSPRATE,
  MODULE_SLUG_YOUTUBETHUMBNAIL,
  MODULE_SLUG_GLOBAL_AP_SETTINGS,
  MODULE_SLUG_MANAGE_ANNOUNCEMENTS,
  MODULE_SLUG_EXT360,
  MODULE_SLUG_VINSTATUS_TRACKER,
  MODULE_SLUG_WINDOW_STICKER_SETTING,
  MODULE_SLUG_WINDOW_STICKER_ORDER,
  MODULE_RATIO_SETTINGS,
  MODULE_SLUG_PROMOBILLBOARD,
  MODULE_VIN_TURNAROUND,
  MODULE_VEH_UPLOAD_HISTORY
} from '../constants/moduleSlugConst';
import { OPEN_SIDEBAR } from '../constants/messageConst';
import { STORAGE_DEALER, STORAGE_TOKEN, STORAGE_USER } from '../constants/storageConst';
import { showMsg } from '../services/library';
import { DEVELOPERS_ACCESS } from '../constants/PermissionConst';

// #region storage related
export const performLogout = (isDirectLogin = false) => {
  if (!isDirectLogin) {
    localStorage.clear();
  }
  sessionStorage.clear();
};
export const retrieveAuthToken = () =>
  sessionStorage.getItem(STORAGE_TOKEN) || localStorage.getItem(STORAGE_TOKEN) || null;

export const retrieveUserDetails = () => {
  try {
    const storageUserDetail = sessionStorage.getItem(STORAGE_USER) || localStorage.getItem(STORAGE_USER);
    return storageUserDetail && storageUserDetail !== 'undefined' && storageUserDetail !== 'null'
      ? JSON.parse(storageUserDetail)
      : null;
  } catch (err) {
    console.error(err);
    return null;
  }
};

export const retrieveDealerDetails = (getSessionVal = false) => {
  const dealerFromSession = sessionStorage.getItem(STORAGE_DEALER);
  const dealerFromLocal = localStorage.getItem(STORAGE_DEALER);

  if (getSessionVal) {
    return dealerFromSession && dealerFromSession !== 'undefined' && dealerFromSession !== 'null'
      ? JSON.parse(dealerFromSession)
      : null;
  }

  try {
    return dealerFromLocal && dealerFromLocal !== 'undefined' && dealerFromLocal !== 'null'
      ? JSON.parse(dealerFromLocal)
      : dealerFromSession && dealerFromSession !== 'undefined' && dealerFromSession !== 'null'
        ? JSON.parse(dealerFromSession)
        : null;
  } catch (error) {
    console.error('Error parsing dealer data:', error);
    return null;
  }
};

// #endregion

// #region permission functions

const MODULE_PATH_MAP = {
  [DASHBOARD_PAGE_PATH]: MODULE_SLUG_DASHBOARD,
  [COMPARISION_PAGE_PATH]: MODULE_SLUG_DEALERCOMPARISON,
  [EDITTRACKER_PAGE_PATH]: MODULE_SLUG_EDITTRACKER,

  [MAVIS_PAGE_PATH]: MODULE_SLUG_MAVIS,
  [MAVIS_GALLERY_PAGE_PATH]: MODULE_SLUG_MAVIS,

  [EXPORT_PAGE_PATH]: MODULE_SLUG_EXPORT,
  [VEHICLE_GALLERY_PAGE_PATH]: MODULE_SLUG_EXPORT,

  [IMPORT_PAGE_PATH]: MODULE_SLUG_IMPORT,

  [INVENTORY_PAGE_PATH]: MODULE_SLUG_INVENTORY,
  [INVENTORY_DETAILS_PAGE_PATH]: MODULE_SLUG_INVENTORY,
  [CONFIRMVDS_GALLERY_PAGE_PATH]: MODULE_SLUG_INVENTORY,

  [DEALERPROFILE_PAGE_PATH]: MODULE_SLUG_DEALERPROFILE,
  [DEALERLOG_PAGE_PATH]: MODULE_SLUG_DEALERPROFILE,

  [USERPROFILE_PAGE_PATH]: MODULE_SLUG_PROFILES,
  [PHOTOGRAPHER_PROFILE_PAGE_PATH]: MODULE_SLUG_PROFILES,

  [ACCOUNTS_PAGE_PATH]: MODULE_SLUG_ACCOUNTS,
  [NOTIFICATIONS_PAGE_PATH]: MODULE_SLUG_ACCOUNTS,
  [TEAMPROFILE_PAGE_PATH]: MODULE_SLUG_ACCOUNTS,
  [PHOTOGRAPHERS_ACCOUNTS_PAGE_PATH]: MODULE_SLUG_ACCOUNTS_CREATION_PHOTOGRAPHER,
  [VIN_STATUS_TRACKER]: MODULE_SLUG_VINSTATUS_TRACKER,

  [SALES_PAGE_PATH]: MODULE_SLUG_SALES,

  [QUALITY_CONTROL_PAGE_PATH]: MODULE_SLUG_QUALITYCONTROL,

  [QUALITY_CONTROL_EDITFLAGS_PAGE_PATH]: MODULE_SLUG_EDITFLAGS,
  [VIDEO_PAGE_PATH]: MODULE_SLUG_VIDEO,
  [INSTA360_PAGE_PATH]: MODULE_SLUG_INSTA360,
  [EXT360_PAGE_PATH]: MODULE_SLUG_EXT360,
  [FILEMANAGER_PAGE_PATH]: MODULE_SLUG_FILEMANAGER,

  [PROMO_BANNERS_PAGE_PATH]: MODULE_SLUG_PROMOTIONALBANNER,
  [PROMO_BILLBOARDS_PAGE_PATH]: MODULE_SLUG_PROMOBILLBOARD,

  //Dealer Settings
  [PAGUIDES_PAGE_PATH]: MODULE_SLUG_PAGUIDESORDER,
  [EXPORT_ORDER_PAGE_PATH]: MODULE_SLUG_EXPORTORDER,
  [MAVIS_SETTINGS_PAGE_PATH]: MODULE_SLUG_MAVISSETTINGS,
  [RATIO_SETTINGS_PAGE_PATH]: MODULE_RATIO_SETTINGS,
  [VIDEOGENERATION_PAGE_PATH]: MODULE_SLUG_VIDEOGENERATION,
  [YOUTUBE_THUMBNAIL_PAGE_PATH]: MODULE_SLUG_YOUTUBETHUMBNAIL,
  // [FEATURE_BANNERS_PAGE_PATH]: MODULE_SLUG_FEATUREBANNERS,

  // Global Settings
  [FAQ_PATH]: MODULE_SLUG_PASETTINGS,
  [EXPORT_DMS_PATH]: MODULE_SLUG_EXPORTDMS,
  [IMPORT_DMS_PATH]: MODULE_SLUG_IMPORTDMS,
  [MASTER_COMPOSITIONS_PAGE_PATH]: MODULE_SLUG_MASTERCOMPOSITIONS,
  [DEFAULT_GUIDES_PAGE_PATH]: MODULE_SLUG_DEFAULTGUIDES,
  [MAVIS_PRESENTS_PAGE_PATH]: MODULE_SLUG_MAVISPRESETS,
  [FEATURE_ICONS_PAGE_PATH]: MODULE_SLUG_FEATUREICONS,
  [FLAGS_PAGE_PATH]: MODULE_SLUG_FLAGS,
  [BODYSTYLES_PAGE_PATH]: MODULE_SLUG_BODYSTYLES,
  [APIKEYS_PAGE_PATH]: MODULE_SLUG_APIKEY,
  [REPORTSETTINGS_PAGE_PATH]: MODULE_SLUG_REPORTSETTINGS,
  [RETRO_OPERATIONS_PATH]: MODULE_SLUG_RETROOPERATIONS,
  // [FEATURE_BANNERS_SETTINGS_PAGE_PATH]: MODULE_SLUG_FEATUREBANNERLIBRARY,
  [REPORT_STATISTICS_PATH]: MODULE_SLUG_REPORTSTATISTICS,
  [WINDOW_STICKER_PRICING_PATH]: MODULE_SLUG_WINDOW_STICKER_SETTING,

  [WINDOW_STICKER_DASHBOARD_PATH]: MODULE_SLUG_WINDOW_STICKER_ORDER,
  [INVOICING_PAGE_PATH]: MODULE_SLUG_INVOICING,
  [INVOICE_LOGS_PAGE_PATH]: MODULE_SLUG_INVOICES,
  [AUTOPORT_SETTINGS_PAGE_PATH]: MODULE_SLUG_GLOBAL_AP_SETTINGS,
  [ANNOUNCEMENT_BANNER_PAGE_PATH]: MODULE_SLUG_MANAGE_ANNOUNCEMENTS,

  // Accounting
  [ACCOUNTING_INVOICES_PAGE_PATH]: MODULE_SLUG_INVOICES,
  [ACCOUNTING_REPORT_PAGE_PATH]: MODULE_SLUG_DOWNLOADREPORTS,
  [ACCOUNTING_INVOICE_SETTINGS_PAGE_PATH]: MODULE_SLUG_INVOICESETTINGS,
  [NEW_INVOICING_PAGE_PATH]: MODULE_SLUG_INVOICES,

  // LSP
  [LSP_RATE_PATH]: MODULE_SLUG_LSPRATE,
  [LSP_INVOICES_PATH]: MODULE_SLUG_LSPRATE,

  [PROMO_BANNER_FAQ_PATH]: MODULE_SLUG_ADMINLOGS,
  [ADMINLOGS_PAGE_PATH]: MODULE_SLUG_ADMINLOGS,
  [USER_ROLES_PATH]: MODULE_SLUG_USERROLES,
  [DEVELOPER_ACCESS_PAGE_PATH]: MODULE_SLUG_DEVELOPER_ACCESS,
  [VIN_TURNAROUND_PAGE_PATH]: MODULE_VIN_TURNAROUND,
  [VEH_UPLOAD_HISTORY_PAGE_PATH]: MODULE_VEH_UPLOAD_HISTORY,

  // AppGlobal:-
  [CRONSTATS_PAGE_PATH]: MODULE_CRON_STATS,
  [INTEGRATION_PAGE_PATH]: MODULE_SOCIAL_MEDIA_INTEGRATION,
  [THEME_DOCS_PAGE_PATH]: MODULE_THEME_DOCS,
  [EDITORPROFILE_PAGE_PATH]: MODULE_MY_PROFILE,
  [EDITOR_REPORT_PAGE_PATH]: MODULE_EDITOR_REPORT,
  [AUTOPORT_SETTINGS_PAGE_PATH]: MODULE_SLUG_GLOBAL_AP_SETTINGS,
  [ANNOUNCEMENT_BANNER_PAGE_PATH]: MODULE_SLUG_MANAGE_ANNOUNCEMENTS
};

export const hasModulePermission = (requiredModules = []) => {
  const user = retrieveUserDetails();
  const permissionModules = Object.keys(user?.user_module_permissiondata || {});
  return requiredModules?.some(item => permissionModules.includes(item));
};
export const hasActionPermission = (requiredActions = [], requiredModule = null, isLogEnabled = false) => {
  const url = location?.pathname || '';
  const secondSlashIndex = url.indexOf('/', 1);
  const pagePathURL = secondSlashIndex !== -1 ? url.substring(0, secondSlashIndex) : url;
  const moduleSlug = !requiredModule ? MODULE_PATH_MAP[pagePathURL] : requiredModule;

  // console.log({ pagePathURL });

  const user = retrieveUserDetails();
  const permissionActions = user?.user_module_permissiondata?.[moduleSlug] || [];

  // console.log({ moduleSlug, d: user.user_module_permissiondata });

  const result = requiredActions?.some(action => permissionActions.includes(action));
  if (isLogEnabled) {
    console.log('pagePathURL', pagePathURL);
    console.log('user', user);
    console.log('moduleSlug', moduleSlug);
    console.log('permissionActions', permissionActions);
    console.log('result', result);
  }
  return result || null;
};

export const hasFirstAccessiblePage = ({ isDirectLogin = false } = {}) => {
  const authToken = retrieveAuthToken();
  const user = retrieveUserDetails();
  const permissionData = user?.user_module_permissiondata ?? null;
  const userModules = permissionData ? Object.keys(permissionData) : [];

  let homePage = LOGIN_PAGE_PATH;

  if (!authToken || !user) {
    performLogout(isDirectLogin);
    return homePage;
  }

  try {
    if (!userModules || userModules?.length === 0) {
      showMsg('You are not having any role assigned.', 'error');
      performLogout(isDirectLogin);
      return homePage;
    }

    const getUrlByModuleSlug = slug => {
      const url = Object.keys(MODULE_PATH_MAP)?.find(key => MODULE_PATH_MAP[key] === slug);
      return url || null;
    };

    const urlPathArr = userModules?.map(role => getUrlByModuleSlug(role));
    if (urlPathArr && urlPathArr?.length > 0) {
      homePage = urlPathArr[0];
    }

    if (homePage === LOGIN_PAGE_PATH) {
      showMsg('You are not having any role assigned.', 'error');
      performLogout(isDirectLogin);
    }
  } catch (err) {
    showMsg(err?.message || 'Error parsing user details.', 'error');
    performLogout(isDirectLogin);
  }
  return homePage;
};

export const isAuthorizedForRoute = ({ pathurl = '' }) => {
  const mapUrlToModule = pathurl => {
    const dealer = retrieveDealerDetails();

    const hasPermission = MODULE_PATH_MAP[pathurl]
      ? hasModulePermission(
          typeof MODULE_PATH_MAP[pathurl] === 'string' ? [MODULE_PATH_MAP[pathurl]] : MODULE_PATH_MAP[pathurl]
        )
      : false;

    // Hide developer access page from non dev users
    if (pathurl === DEVELOPER_ACCESS_PAGE_PATH) {
      const user = retrieveUserDetails();
      const isDevUser = DEVELOPERS_ACCESS.includes(user?.user_email);
      return isDevUser;
    }

    if (pathurl === OURMISSION_PAGE_PATH) {
      return true;
    }
    if (pathurl === BGERROR_GALLERY_PAGE_PATH_VEHID) {
      return true;
    }

    // Additional checks for specific dealer permissions
    if (pathurl === PROMO_BANNERS_PAGE_PATH) {
      return dealer?.promoBanner && hasPermission;
    }
    if (pathurl === INTEGRATION_PAGE_PATH) {
      return dealer?.integration || hasPermission;
    }
    if (pathurl === WINDOW_STICKER_DASHBOARD_PATH) {
      return dealer?.allowStickerOrderDashboard && hasPermission;
    }
    return hasPermission;
  };

  const statusModulePermission = mapUrlToModule(pathurl);
  return statusModulePermission;
};
// #endregion

export const checkIsEditorRole = role_slug => {
  if (typeof role_slug === 'string') {
    const words = role_slug.split('-');
    const [type] = words;
    return type === 'editor';
  }
  return false;
};
export const checkIsPhotographerRole = role_slug => {
  if (typeof role_slug === 'string') {
    const words = role_slug.split('-');
    const [type] = words;
    return type === 'photographer';
  }
  return false;
};
export const checkIsAdminRole = role_slug => {
  if (typeof role_slug === 'string') {
    const words = role_slug.split('-');
    const [type] = words;
    return type === 'administrator';
  }
  return false;
};
export const checkIsDealershipRole = role_slug => {
  if (typeof role_slug === 'string') {
    const words = role_slug.split('-');
    const [type] = words;
    return type === 'dealership';
  }
  return false;
};
export const checkIsDeveloperRole = user_email => {
  if (typeof user_email === 'string') {
    return DEVELOPERS_ACCESS.includes(user_email);
  }
  return false;
};

export const getTypeSupportedRoles = (roles, type) => {
  const list = JSON.parse(JSON.stringify(roles));

  const supportedRoles = list.filter(
    i => i.role_slug.split('-')[0] === type && i.role_allow_assignment === 1
  );

  return supportedRoles;
};

//  #region Sidebar options
export const navigationItemsMenuList = () => {
  const handleNestedMenuClick = event => {
    const element = event.currentTarget;
    if (element) {
      if (element.classList.contains(OPEN_SIDEBAR)) {
        element.classList.remove(OPEN_SIDEBAR);
      } else {
        element.classList.add(OPEN_SIDEBAR);
      }
    }
  };

  const createMenuItem = (link, icon, options = {}) => {
    return {
      link,
      icon,
      get label() {
        return getTitleOfPage(this.link);
      },
      get isvisible() {
        return isAuthorizedForRoute({ pathurl: this.link });
      },
      ...options
    };
  };

  return [
    createMenuItem(DASHBOARD_PAGE_PATH, 'fa-line-chart'),
    createMenuItem(PHOTOGRAPHERS_ACCOUNTS_PAGE_PATH, 'fa-user-circle'),
    createMenuItem(COMPARISION_PAGE_PATH, 'fa-th'),
    createMenuItem(EDITTRACKER_PAGE_PATH, 'fa-sliders'),
    createMenuItem(MAVIS_PAGE_PATH, 'icon-ic_mavis'),
    createMenuItem(EXPORT_PAGE_PATH, 'fa-upload'),
    createMenuItem(IMPORT_PAGE_PATH, 'fa-download'),
    createMenuItem(INVENTORY_PAGE_PATH, 'fa-list-ul'),
    createMenuItem(DEALERPROFILE_PAGE_PATH, 'fa-user-plus'),
    createMenuItem(PHOTOGRAPHER_PROFILE_PAGE_PATH, 'fa-user-o'),
    createMenuItem(ACCOUNTS_PAGE_PATH, 'fa-user-circle'),
    createMenuItem(QUALITY_CONTROL_PAGE_PATH, 'fa-check-square-o'),
    createMenuItem(QUALITY_CONTROL_EDITFLAGS_PAGE_PATH, 'fa-check-square'),
    createMenuItem(VIDEO_PAGE_PATH, 'fa-video-camera'),
    createMenuItem(INSTA360_PAGE_PATH, 'fa-street-view'),
    createMenuItem(EXT360_PAGE_PATH, 'fa-circle-thin'),
    createMenuItem(FILEMANAGER_PAGE_PATH, 'fa-folder-open'),
    createMenuItem(PROMO_BANNERS_PAGE_PATH, 'fa-window-restore'),
    createMenuItem(PROMO_BILLBOARDS_PAGE_PATH, 'fa-outdent'),
    {
      label: 'Dealer Settings',
      icon: 'fa-cog',
      isvisible: hasModulePermission([
        MODULE_SLUG_PAGUIDESORDER,
        MODULE_SLUG_EXPORTORDER,
        MODULE_SLUG_MAVISSETTINGS,
        MODULE_SLUG_VIDEOGENERATION,
        MODULE_SLUG_YOUTUBETHUMBNAIL,
        MODULE_SLUG_FEATUREBANNERS,
        MODULE_RATIO_SETTINGS
      ]),
      nestedMenuOnClick: handleNestedMenuClick,
      submenu: [
        createMenuItem(PAGUIDES_PAGE_PATH, 'fa-check'),
        createMenuItem(EXPORT_ORDER_PAGE_PATH, 'fa-list-ol'),
        createMenuItem(MAVIS_SETTINGS_PAGE_PATH, 'fa-cogs'),
        createMenuItem(RATIO_SETTINGS_PAGE_PATH, 'fa-expand'),
        createMenuItem(VIDEOGENERATION_PAGE_PATH, 'fa-video-camera'),
        createMenuItem(YOUTUBE_THUMBNAIL_PAGE_PATH, 'fa-youtube-play')
        // createMenuItem(FEATURE_BANNERS_PAGE_PATH, 'fa-check-circle')
      ]
    },
    {
      label: 'Global Settings',
      icon: 'fa-universal-access',
      isvisible: hasModulePermission([
        MODULE_SLUG_PASETTINGS,
        MODULE_SLUG_EXPORTDMS,
        MODULE_SLUG_MASTERCOMPOSITIONS,
        MODULE_SLUG_DEFAULTGUIDES,
        MODULE_SLUG_MAVISPRESETS,
        MODULE_SLUG_FEATUREICONS,
        MODULE_SLUG_FLAGS,
        MODULE_SLUG_BODYSTYLES,
        MODULE_SLUG_APIKEY,
        MODULE_SLUG_REPORTSETTINGS,
        MODULE_SLUG_RETROOPERATIONS,
        MODULE_SLUG_FEATUREBANNERLIBRARY,
        MODULE_SLUG_REPORTSTATISTICS,
        MODULE_SLUG_MANAGE_ANNOUNCEMENTS,
        MODULE_SLUG_GLOBAL_AP_SETTINGS,
        MODULE_SLUG_WINDOW_STICKER_SETTING
      ]),
      nestedMenuOnClick: handleNestedMenuClick,
      submenu: [
        createMenuItem(FAQ_PATH, 'fa-question'),
        createMenuItem(EXPORT_DMS_PATH, 'fa-file-text-o'),
        createMenuItem(IMPORT_DMS_PATH, 'fa-file-text-o'),
        createMenuItem(MASTER_COMPOSITIONS_PAGE_PATH, 'fa-cube'),
        createMenuItem(DEFAULT_GUIDES_PAGE_PATH, 'fa-thumbs-o-up'),
        createMenuItem(MAVIS_PRESENTS_PAGE_PATH, 'fa-fw fa-magic'),
        createMenuItem(FEATURE_ICONS_PAGE_PATH, 'fa-paperclip'),
        createMenuItem(FLAGS_PAGE_PATH, 'fa-flag-o'),
        createMenuItem(BODYSTYLES_PAGE_PATH, 'fa-bookmark-o'),
        createMenuItem(APIKEYS_PAGE_PATH, 'fa-key'),
        createMenuItem(REPORTSETTINGS_PAGE_PATH, 'fa-envelope'),
        createMenuItem(RETRO_OPERATIONS_PATH, 'fa-repeat'),
        // createMenuItem(FEATURE_BANNERS_SETTINGS_PAGE_PATH, 'fa-clone'),
        createMenuItem(REPORT_STATISTICS_PATH, 'fa-area-chart'),
        createMenuItem(ANNOUNCEMENT_BANNER_PAGE_PATH, 'fa-bullhorn'),
        createMenuItem(AUTOPORT_SETTINGS_PAGE_PATH, 'fa-wrench'),
        createMenuItem(PROMO_BANNER_FAQ_PATH, 'fa-question-circle'),
        createMenuItem(WINDOW_STICKER_PRICING_PATH, 'fa-cog'),
        createMenuItem(VEH_UPLOAD_HISTORY_PAGE_PATH, 'fa-history')
      ]
    },
    createMenuItem(WINDOW_STICKER_DASHBOARD_PATH, 'fa-file'),
    createMenuItem(INVOICING_PAGE_PATH, 'fa-dollar'),
    {
      label: 'Accounting',
      icon: 'fa-book',
      isvisible: hasModulePermission([MODULE_SLUG_DOWNLOADREPORTS, MODULE_SLUG_INVOICESETTINGS]),
      nestedMenuOnClick: handleNestedMenuClick,
      submenu: [
        createMenuItem(ACCOUNTING_INVOICES_PAGE_PATH, 'fa-file'),
        createMenuItem(NEW_INVOICING_PAGE_PATH, 'fa-credit-card'),
        createMenuItem(ACCOUNTING_REPORT_PAGE_PATH, 'fa-download'),
        createMenuItem(ACCOUNTING_INVOICE_SETTINGS_PAGE_PATH, 'fa-list-alt'),
        createMenuItem(INVOICE_LOGS_PAGE_PATH, 'fa-list')
      ]
    },
    {
      label: 'LSP',
      icon: 'fa-dollar',
      isvisible: hasModulePermission([MODULE_SLUG_LSPRATE]),
      nestedMenuOnClick: handleNestedMenuClick,
      submenu: [createMenuItem(LSP_RATE_PATH, 'fa-gear'), createMenuItem(LSP_INVOICES_PATH, 'fa-list-alt')]
    },
    createMenuItem(ADMINLOGS_PAGE_PATH, 'fa-id-badge'),
    createMenuItem(VIN_STATUS_TRACKER, 'fa-table'),
    createMenuItem(VIN_TURNAROUND_PAGE_PATH, 'fa-exchange'),
    createMenuItem(USER_ROLES_PATH, 'fa-users'),
    createMenuItem(DEVELOPER_ACCESS_PAGE_PATH, 'fa-code')

    /*
     createMenuItem(TTM_PAGE_PATH, 'icon-ttm_icon'),
      { label: 'Accounting',icon: 'fa-book',link: '/accounting', isvisible: hasModulePermission(userRoles,[]) ,
       nestedMenuOnClick: handleNestedMenuClick,
       submenu: [
        createMenuItem('/accounting', 'fa-gears'),
        createMenuItem('/billinggroups', 'fa-list-alt')
      ],
      createMenuItem(SALES_PAGE_PATH, 'fa-bar-chart'),
    */
  ];
};
// #endregion
